const actionConstants = {
  FILTERS: {
    SORT_BY: {
      OLD_TO_RECENT: "OLD_TO_RECENT",
      RECENT_TO_OLD: "RECENT_TO_OLD",
    },
    LABELS: {
      ADD_LABEL: "ADD_LABEL",
      REMOVE_LABEL: "REMOVE_LABEL",
    },
    REMOVE_FILTERS: "REMOVE_FILTERS",
    PRIORITY_ALLOTMENTS: {
      HIGH_PRIORITY: "HIGH_PRIORITY",
      MEDIUM_PRIORITY: "MEDIUM_PRIORITY",
      LOW_PRIORITY: "LOW_PRIORITY",
    },
  },
  INPUT_ACTIONS: {
    UPDATE_TITLE: "UPDATE_TITLE",
    UPDATE_DESCRIPTION: "UPDATE_DESCRIPTION",
    UPDATE_COLOR: "UPDATE_COLOR",
    UPDATE_PRIORITY: "UPDATE_PRIORITY",
    UPDATE_EXISTING_DATA: "UPDATE_EXISTING_DATA",
    UPDATE_PIN_STATUS: "UPDATE_PIN_STATUS",
    LABELS: {
      ADD_LABEL: "ADD_LABEL",
      REMOVE_LABEL: "REMOVE_LABEL",
    },
    RESET_INPUT_DATA: "RESET_INPUT_DATA",
  },
};
export { actionConstants };
